// Zikra: reveal-on-scroll for .zk-reveal elements. Content stays visible if this never runs.
(() => {
  document.documentElement.classList.add('zk-js');
  const reveal = (el) => el.classList.add('is-in');

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.zk-reveal').forEach(reveal);
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        reveal(entry.target);
        io.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  const observe = (root = document) => root.querySelectorAll('.zk-reveal:not(.is-in)').forEach((el) => io.observe(el));
  observe();

  // Theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
})();
